var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Type from './Type';

var H5 = function H5(_ref) {
  var size = _ref.size,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ['size', 'children', 'className']);

  var classes = classnames(className, _defineProperty({}, 'o-type-' + size, size));

  return React.createElement(
    Type,
    _extends({ tagName: 'h5', className: classes }, props),
    children
  );
};

H5.propTypes = {
  size: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
};

export default H5;